<template>
  <div class="contact-page">
    <div>
      <PageHeader
        :links="[
          { url: '/', label: 'Home' },
          { url: '/#service', label: 'Service' },
          { url: '/#pricing', label: 'Pricing' },
          { url: '/#faq', label: 'FAQ' },
        ]"
      />
      <main>
        <PageBlock>
          <div class="head">
            <h1>Contact us</h1>
          </div>
          <DashboardCard>
            <form @submit.prevent="submit()">
              <div class="sm:p-2">
                <div class="grid grid-cols-1 gap-4">
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8">
                    <FwbInput v-model="name" label="Name *" />
                    <FwbInput v-model="company" label="Company" />
                    <FwbInput v-model="email" label="Email *" />
                    <FwbInput v-model="phone" label="Phone" />
                  </div>
                  <FwbTextarea v-model="message" label="Message *" />
                </div>
                <BlueButton class="mt-6">
                  Send message
                  <template #prefix>
                    <DashboardIconMessage class="w-5 h-5" />
                  </template>
                </BlueButton>
              </div>
            </form>
          </DashboardCard>
        </PageBlock>
      </main>
    </div>
    <PageFooter />
  </div>
</template>

<script setup lang="ts">
import { FwbInput, FwbTextarea } from "flowbite-vue";
import { load as loadRecaptcha } from "recaptcha-v3";

const { app } = useRuntimeConfig();

useHead({
  title: "Otago - Contact",
});

const name = ref("");
const company = ref(useCompany().value?.name || "");
const email = ref(useUser().value?.email || "");
const phone = ref("");
const message = ref("");

if (import.meta.browser) {
  await loadRecaptcha(app.recaptchaPublicKey, { autoHideBadge: true });
}

async function submit() {
  const recaptcha = await loadRecaptcha(app.recaptchaPublicKey);
  const token = await recaptcha.execute("contact");

  const params = {
    name: name.value,
    company: company.value,
    email: email.value,
    phone: phone.value,
    message: message.value,
    recaptcha: token,
  };
  const { error } = await api_post_contact(params);
  if (error.value) {
    setFlashMessage({ type: "danger", message: error.value.data.message as string, durationMs: 4000 });
  } else {
    setFlashMessage({ type: "success", message: "Message sent", durationMs: 2000 });
    message.value = "";
  }
}
</script>

<style scoped>
.contact-page {
  @apply flex flex-col justify-between min-h-screen;

  .head {
    @apply py-4 lg:py-8 px-4 mx-auto max-w-screen-xl text-center;

    h1 {
      @apply mb-4 text-3xl font-extrabold tracking-tight leading-none md:text-5xl dark:text-blue-400;
    }
  }
}
</style>
